import { render, staticRenderFns } from "./WarehouseBehavior.vue?vue&type=template&id=070c19b0&scoped=true&"
import script from "./WarehouseBehavior.vue?vue&type=script&lang=js&"
export * from "./WarehouseBehavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c19b0",
  null
  
)

export default component.exports